<template>
  <form @submit.prevent>
    <!--        You can switch " data-color="primary" "  with one of the next bright colors: "green", "orange", "red", "blue"       -->
    <div class="text-center pt-80">
      <h2 class="title">방내놓기</h2>
      <div class="col-lg-10 col-md-11 pt-20" style="margin: auto">
        <div>
          <ul class="nav nav-pills" role="tablist" style="margin: auto">
            <li
              v-for="(tab, index) in tabs"
              :key="tab.title"
              role="tab"
              :tabindex="tab.checked ? 0 : ''"
              :id="`step-${tab.tabId}`"
              :aria-controls="tab.tabId"
              :aria-disabled="tab.active"
              :aria-selected="tab.active"
              :ref="`tab-${index}`"
              class="nav-item wizard-tab-link jipvio-step-li"
            >
              <a
                class="nav-link"
                @click="navigateToTab(index)"
                :class="[
                  { 'disabled-wizard-link': !tab.checked },
                  { active: tab.active },
                  { checked: tab.checked }
                ]"
                data-toggle="tab"
              >
                <a class="nav-number-round"> {{ index + 1 }} </a>
                <tab-item-content :tab="tab"></tab-item-content>
              </a>
              <a
                v-if="index + 1 !== tabCount"
                style="font-size: 40px; color: #e0e0e0; position:absolute; bottom: 1.2vh; right:-6vw; height: 100%;"
                ><i class="el-icon-arrow-right" style="font-size: 40px;"></i
              ></a>
            </li>
          </ul>
        </div>
      </div>
      <!--
            <div
              class="moving-tab"
              :class="{ 'error-link': activeTab.hasError }"
              v-if="activeTab"
              style="transition: transform 0.5s cubic-bezier(0.29, 1.42, 0.79, 1); width: 100%;"
              :style="movingTabStyles"
            >
              <tab-item-content
                :tab="activeTab"
                :moving-tab="true"
              ></tab-item-content>
            </div>
      -->
    </div>

    <slot :activeIndex="activeTabIndex" :activeTab="activeTab"></slot>

    <slot name="footer" :next-tab="nextTab" :prev-tab="prevTab">
      <div class="col-md-10 m-auto">
        <div class="">
          <div class="pull-right">
            <n-button
              v-if="activeTabIndex < tabCount - 1"
              wide
              @click.native="nextTab"
              class="btn-next"
              >{{ nextButtonText }}</n-button
            >
            <n-button v-else wide @click.native="nextTab">
              {{ finishButtonText }}
            </n-button>
          </div>

          <div class="pull-left">
            <n-button
              v-if="activeTabIndex > 0"
              wide
              @click.native="prevTab"
              class="btn-previous"
              >{{ prevButtonText }}</n-button
            >
          </div>
          <div class="clearfix"></div>
        </div>
      </div>
    </slot>
  </form>
</template>
<script>
import { throttle } from "./throttle";
import { Button } from "@/components";
import { MessageBox } from "element-ui";

export default {
  name: "simple-wizard-agt",
  props: {
    startIndex: {
      type: Number,
      default: 0
    },
    title: {
      type: String,
      default: "제목"
    },
    subTitle: {
      type: String,
      default: "부제목"
    },
    prevButtonText: {
      type: String,
      default: "이전"
    },
    nextButtonText: {
      type: String,
      default: "다음"
    },
    finishButtonText: {
      type: String,
      default: "완료"
    },
    vertical: {
      type: Boolean
    }
  },
  components: {
    [Button.name]: Button,
    [MessageBox.name]: MessageBox,
    TabItemContent: {
      props: ["tab", "movingTab"],
      render(h) {
        return h("span", [this.tab.$slots.label || this.tab.label]);
      }
    }
  },
  provide() {
    return {
      addTab: this.addTab,
      removeTab: this.removeTab
    };
  },
  data() {
    return {
      tabs: [],
      activeTabIndex: 0,
      tabLinkWidth: 0,
      tabLinkHeight: 50
    };
  },
  computed: {
    tabCount() {
      return this.tabs.length;
    },

    linkWidth() {
      let width = 25;
      let height = "50px";
      /*
      if (this.tabCount > 0) {
        width = 100 / this.tabCount;
      }
      */
      if (this.vertical) {
        width = 50;
      }
      return { width: `${width}%`, height: "50px" };
      // return { width: "25%", height: "50px" };
    },
    linkHeight() {
      let height = 50;
      if (this.tabCount > 0) {
        height = 50 / this.tabCount;
      }
      if (this.vertical) {
        height = 50;
      }
      return { height: "50px" };
    },
    activeTab() {
      return this.tabs[this.activeTabIndex];
    },
    movingTabStyles() {
      let translateXValue = this.tabLinkWidth * this.activeTabIndex;
      let translateYValue = 0;
      if (this.vertical) {
        translateYValue = this.tabLinkHeight * this.activeTabIndex;
        translateXValue = 0;
      }
      let styles = {
        transform: `translate3d(${translateXValue}px, ${translateYValue}px, 0px)`
      };
      if (this.tabLinkWidth !== 0) {
        styles.width = `${this.tabLinkWidth}px`;
      }
      return styles;
    }
  },

  created() {},

  methods: {
    addTab(tab) {
      const index = this.$slots.default.indexOf(tab.$vnode);
      let tabTitle = tab.title || "";
      tab.tabId = `${tabTitle.replace(/ /g, "")}${index}`;
      if (!this.activeTab && index === 0) {
        tab.active = true;
        tab.checked = true;
      }
      if (this.activeTab === tab.name) {
        tab.active = true;
        tab.checked = true;
      }
      this.tabs.splice(index, 0, tab);
    },
    removeTab(tab) {
      const tabs = this.tabs;
      const index = tabs.indexOf(tab);
      if (index > -1) {
        tabs.splice(index, 1);
      }
    },
    validate(tab) {
      let tabToValidate = tab || this.activeTab;
      let beforeChange = tabToValidate.beforeChange;
      if (beforeChange) {
        return Promise.resolve(beforeChange())
          .then(res => {
            this.activeTab.hasError = res ? false : true;
            return res;
          })
          .catch(() => {
            this.activeTab.hasError = true;
          });
      } else {
        return Promise.resolve(true);
      }
    },
    async nextTab() {
      let isValid = await this.validate();
      if (isValid && this.activeTabIndex < this.tabCount - 1) {
        this.activeTabIndex++;
      }
      return isValid;
    },
    prevTab() {
      MessageBox.confirm("이전 페이지로 이동 하시겠습니까?", "Warning", {
        confirmButtonText: "예",
        cancelButtonText: "아니오",
        type: "warning"
      })
        .then(() => {
          console.log("agree------------------------");
          // 임시저장 로직
          let tabToValidate = this.activeTab;
          let saveCheck = tabToValidate.saveCheck;
          if (saveCheck) {
            saveCheck();
          }
          this.activeTabIndex--;
        })
        .catch(() => {
          console.log("disagree------------------------");
        })
        .finally(() => {
          // 탭이동
          // this.activeTabIndex--;
        });
    },
    async navigateToTab(index) {
      if (this.tabs[index].checked) {
        // recursively validate each tab
        if (index > this.activeTabIndex) {
          let valid = await this.nextTab();
          if (valid) {
            this.navigateToTab(index);
          }
        } else {
          // 임시저장 로직
          if (index < this.activeTabIndex) {
            // 임시저장 로직
            let tabToValidate = this.activeTab;
            let saveCheck = tabToValidate.saveCheck;
            if (saveCheck) {
              saveCheck();
            }

            // 탭이동
            this.activeTabIndex = index;
          }

          // if (index < this.activeTabIndex) {
          //   MessageBox.confirm(
          //     "This will permanently delete the file. Continue?",
          //     "Warning",
          //     {
          //       confirmButtonText: "OK",
          //       cancelButtonText: "Cancel",
          //       type: "warning"
          //     }
          //   )
          //     .then(() => {
          //       console.log("agree------------------------");
          //       // 임시저장 로직
          //       let tabToValidate = this.activeTab;
          //       let saveCheck = tabToValidate.saveCheck;
          //       if (saveCheck) {
          //         saveCheck();
          //       }
          //     })
          //     .catch(() => {
          //       console.log("disagree------------------------");
          //     })
          //     .finally(() => {
          //       // 탭이동
          //       this.activeTabIndex = index;
          //     });

          // 탭이동
          this.activeTabIndex = index;
        }
      }
    },
    onResize() {
      let tabLinks = document.getElementsByClassName("wizard-tab-link");
      if (tabLinks.length > 0 && this.tabCount > 0) {
        let { clientWidth, clientHeight } = tabLinks[0];
        this.tabLinkWidth = clientWidth;
        this.tabLinkHeight = clientHeight;
      }
    }
  },
  mounted() {
    const self = this;

    this.$root.$on("agt_step1_agree", function() {
      self.nextTab();
    });
    this.activeTabIndex = this.startIndex;
    this.$nextTick(() => {
      this.tabs[this.activeTabIndex].active = true;
      this.tabs[this.activeTabIndex].checked = true;
      this.onResize();
    });
    window.addEventListener(
      "resize",
      () => {
        throttle(this.onResize, 40);
      },
      false
    );
  },
  watch: {
    activeTabIndex(newValue, oldValue) {
      if (newValue !== oldValue) {
        let oldTab = this.tabs[oldValue];
        let newTab = this.tabs[newValue];
        oldTab.active = false;
        newTab.active = true;

        if (!newTab.checked) {
          newTab.checked = true;
        }
        this.$emit("tab-change", oldTab, newTab);
        this.$emit("update:startIndex", newValue);
      }
    }
  }
};
</script>
<style lang="scss"></style>
